export function hasActiveSearch(searchInput = '', search = '') {
    return String(searchInput || search || '').trim().length > 0;
}

export function getSearchEmptyMessage(searchValue = '') {
    const trimmedSearch = String(searchValue || '').trim();
    if (!trimmedSearch) {
        return 'No se encontraron resultados para tu búsqueda';
    }
    return `No se encontraron resultados para "${trimmedSearch}"`;
}
